<template>
  <a :href="item.url_link" class="block" key="hover" v-if="item">
    <strong class="flex items-center mb-4 text-2xl tracking-wider" v-if="item.top_text" v-text="item.top_text"></strong>

    <img
      class="rounded-lg"
      v-if="item.image"
      :src="`${item.image.url}?tr=w-440,h-290`"
      :srcset="`${item.image.url}?tr=w-880,h-580 2x`"
      width="440"
      height="290"
      :alt="item.image.alt ? item.image.alt : item.title"
    />

    <div class="h-16">
      <p class="mt-4 text-lg" v-if="item.title" v-text="item.title"></p>

      <div class="leading-tight">
        <span class="text-sm" v-if="item.subtitle" v-text="item.subtitle"></span>
      </div>
    </div>
  </a>
</template>
<script>
export default {
  computed: {
    item() {
      return window?.capes?.heroContent ?? {}
    },
  },
}
</script>
